import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=d23a07a0&scoped=true&"
import script from "./SearchList.vue?vue&type=script&lang=js&"
export * from "./SearchList.vue?vue&type=script&lang=js&"
import style0 from "./SearchList.vue?vue&type=style&index=0&id=d23a07a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a07a0",
  null
  
)

export default component.exports